import {isNumber} from 'bootstrap-vue/esm/utils/inspect'

const url = '/lots'
export default {
    namespaced: true,
    state: () => ({
        list: [],
        filters: {},
        sort: {
            sortBy: 'id',
            sortDirection: 'desc'
        },
        meta: window.regionTorg?.preload?.lots?.meta ?? {},

        loading: false,
        error: false,
        firstLoad: false,
    }),
    mutations: {
        loadingProcess: state => state.loading = true,
        loadingComplete: state => state.loading = false,
        error: (state, errorTxt) => state.error = errorTxt ?? false,
        setList: (state, newList) => state.list = newList,
        setFilters: (state, filters) => {
            state.filters = {...filters}
            state.meta.current_page = 1
        },
        setFromUser: (state, fromUser) => {
            if(fromUser) {
                state.filters.fromUser = 1
                if(isNumber(fromUser)) {
                    state.filters.userId = fromUser
                }
            } else {
                delete state.filters?.fromUser
                delete state.filters?.userId
            }
        },
        setMeta: (state, meta) => state.meta = { ...meta },
        setSort: (state, sort) => state.sort = { ...sort },
        setFirstLoad: (state, firstLoad) => state.firstLoad = firstLoad,
        resetPage: (state) => state.meta.current_page = 1,
    },
    actions: {
        async preloadLots({ dispatch, commit }) {
            const data = window.regionTorg?.preload?.lots
            if(data) {
                commit('setList', data.data)
                commit('setMeta', data.meta)
                commit('setFirstLoad', true)
                window.regionTorg.preload.lots = null;
                return;
            }
            return dispatch('fetchLots')
        },

        async fetchLots({commit, state}, page = state.meta.current_page ?? 1) {


            commit('loadingProcess')
            commit('setList', [])
            commit('error', false)
            commit('setMeta', {})

            try {
                const {data} = await axios.get(url, {params: {page, ...state.filters, ...state.sort}})
                commit('setList', data.data)
                commit('setMeta', data.meta)
            } catch (error) {
                commit('error', error.response?.data?.message || error.message)
            }
            commit('loadingComplete')
        },
    }
}
